import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import axios from 'axios'
import { isIOS, isAndroid, isMobile } from "./cjxfDefine";
import { Button,Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/button.css';
import 'element-ui/lib/theme-chalk/message.css';
Vue.use(Button)
Vue.config.productionTip = process.env.VUE_APP_PRODUCTION;

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

Vue.prototype.$axios = axios;
// https://gist.github.com/jsoverson/4963116 一种思路
Vue.prototype.$cjxfIsAndroid = isAndroid;
Vue.prototype.$cjxfIsIOS = isIOS;
Vue.prototype.$cjxfIsMobile = isMobile;
Vue.prototype.$message = Message;
// 添加统计代码
if (process.env.VUE_APP_PRODUCTION) {

    // 51la统计
    document.write('<script type="text/javascript"  src="https://js.users.51.la/19752775.js"></script>');

    // 站长统计
    const cnzz_protocol = (("https:" == document.location.protocol) ? " https://" : " http://");
    document.write(unescape("%3Cspan id='cnzz_stat_icon_1275469955'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s5.cnzz.com/z_stat.php%3Fid%3D1275469955' type='text/javascript'%3E%3C/script%3E"));
}


router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    // console.log(to.redirectedFrom);
    next();
});


new Vue({
    router,

    render: h => h(App),
    created: function () {
    },
}).$mount('#app')
